import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";

import useComponentVisible from "../../../../../hooks/useComponentVisible";

import { ChannelWrapper, ChannelMain, Wrapper, ChannelIcon } from "../SideBarChannels.styled";

const QualificationQuestionsTab = ({ setShowAts, active, channel }) => {
  const { ref } = useComponentVisible(false);
  const onClick = useCallback(() => setShowAts(true), [setShowAts]);
  const { t } = useTranslation();

  return (
    <ChannelWrapper ref={ref}>
      <ChannelMain active={active} onClick={onClick}>
        <Wrapper>
          <ChannelIcon src={`/images/icons-channels/ats.svg`} size={27} ml={-1} />
          {t("Qualification Questions")}
        </Wrapper>
      </ChannelMain>
    </ChannelWrapper>
  );
};

export default QualificationQuestionsTab;
